import { financialStatementsKeys } from '../../features/financialStatements/queries/financialStatementsQueryKeys'
import customReportQueryKeys from '../../features/customReport/queries/customReportQueryKeys'
import budgetingScenarioQueryKeys from '../../features/scenario/queries/budgetingScenario/budgetingScenarioQueryKeys'
import forecastQueryKeys from '../../features/scenario/queries/forecast/forecastQueryKeys'
import companyGroupSettingQueryKeys from '../../features/companyGroup/queries/companyGroupSetting/companyGroupSettingQueryKeys'
import { amendmentKeys } from '../../features/amendment/queries/amendmentQueryKeys'
import { budgetCommentsKeys } from '../../features/budgetComments/queries/budgetCommentsQueryKeys'
import { budgetingMethodQueryKeys } from '../../features/budgetingMethod/queries/budgetingMethodQueryKeys'
import { deprecationPlanQueryKeys } from '../../features/deprecationPlan/queries/deprecationPlanQueryKeys'
import { investmentQueryKeys } from '../../features/investment/queries/investmentQueryKeys'
import loanQueryKeys from '../../features/loan/queries/loanQueryKeys'

// Mirrors the backend cache invalidation graph (event → affected query keys).
// refetch: immediately refetch if active, invalidate if inactive
// stale:   mark stale only, no immediate refetch (heavy report queries)

export type CacheInvalidation = {
  refetch: ReadonlyArray<readonly unknown[]>
  stale: ReadonlyArray<readonly unknown[]>
}

export const reportQueryKeys: ReadonlyArray<readonly unknown[]> = [
  financialStatementsKeys.all,
  customReportQueryKeys.sections()
]

// BudgetingScenariosUpdated
const BudgetingScenario: CacheInvalidation = {
  refetch: [
    budgetingScenarioQueryKeys.all,
    forecastQueryKeys.all,
    companyGroupSettingQueryKeys.all,
    amendmentKeys.all,
    budgetCommentsKeys.all,
    budgetingMethodQueryKeys.all,
    deprecationPlanQueryKeys.all,
    investmentQueryKeys.all,
    loanQueryKeys.all
  ],
  stale: reportQueryKeys
}

const cacheInvalidationGraph: Record<string, CacheInvalidation> = {
  BudgetingScenario
}

export default cacheInvalidationGraph
